import "../pages/communication/Report.css";
import logo from "../assets/logo.png";
import { useAtom } from "jotai";
import { companyAtom } from "@/store/company";

interface ReportHeaderProps {
  title?: string;
}

const ReportHeader = ({ title }: ReportHeaderProps) => {
  const [company] = useAtom(companyAtom);
  return (
    <div className="flex flex-col mt-2">
      {title ? (
        <>
          <div className="w-full flex justify-between py-4 px-6 h-[100px] items-center">
            <img src={logo} className="w-[280px]" alt="ECCO Network Logo" />
            {company?.logo && (
              <img src={company.logo} className="h-[100px]" alt="Company Logo" />
            )}
          </div>

          <div className="bg-primary px-6 max-w-[850px] text-black text-2xl font-bold flex items-center">
            <span className="mb-4">{title}</span>
          </div>
        </>
      ) : (
        <div className="w-full flex justify-end py-4 px-6 h-[120px]">
          {company?.logo && (
            <img src={company.logo} className="h-[120px]" alt="Company Logo" />
          )}
        </div>
      )}
    </div>
  );
};

export default ReportHeader;
